import spinRoute from '../../router/spinRoute';

export default () => [
    {
        path: '/okr',
        // 横屏 setFullScreen: true 隐藏头部和底部：hideBarHead: true，hideBarFoot：true
        meta: { title: 'OKR', hideBarHead: true, hideBarFoot: true },
        component: () => spinRoute.require(import('./okrHome.vue')),
    },
    {
        path: '/okr/enter',
        meta: { hideBarHead: true, hideBarFoot: true },
        component: () => spinRoute.require(import('./enter.vue')),
        children: [
            {
                path: '/okr/Self',
                component: () => spinRoute.require(import('./myOkr/fillOkr.vue')),
                meta: { hideBarHead: true, hideBarFoot: true },
            },
            {
                path: '/okr/assessSelfDetail', //自评详情页
                component: () => spinRoute.require(import('./myOkr/okrAssessPages/assessSelfDetail.vue')),
                meta: { title: '评估详情', hideBarHead: true, hideBarFoot: true },
            },
            {
                path: '/okr/addObject',
                component: () => spinRoute.require(import('./myOkr/addObject.vue')),
                meta: { title: '添加目标', hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/krDetail',
                component: () => spinRoute.require(import('./myOkr/krDetail.vue')),
                meta: { title: 'KR详情', hideBarHead: true, hideBarFoot: true },
            },
            {
                path: '/okr/fav',
                component: () => spinRoute.require(import('./views/focusList.vue')),
                meta: { hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/subfav',
                component: () => spinRoute.require(import('./myOkr/fillOkr.vue')),
                meta: { hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/atm',
                component: () => spinRoute.require(import('./views/atme.vue')),
                meta: { hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/subatm',
                component: () => spinRoute.require(import('./myOkr/fillOkr.vue')),
                meta: { hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/SelfMsg',
                component: () => spinRoute.require(import('./views/myMessage.vue')),
                meta: { hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/org',
                component: () => spinRoute.require(import('./org/org.vue')),
                meta: { hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/goal',
                component: () => spinRoute.require(import('./myOkr/fillOkr.vue')),
                meta: { hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/per',
                component: () => spinRoute.require(import('./myOkr/fillOkr.vue')),
                meta: { hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/sub',
                component: () => spinRoute.require(import('./mySubordinate/mySub.vue')),
                meta: { title: '', hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/subsub',
                component: () => spinRoute.require(import('./myOkr/fillOkr.vue')),
                meta: { title: '下属绩效', hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/join',
                component: () => spinRoute.require(import('./views/360assess.vue')),
                meta: { title: '360评估', hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/subjoin',
                component: () => spinRoute.require(import('./myOkr/fillOkr.vue')),
                meta: { title: '360评估', hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/mrpt',
                component: () => spinRoute.require(import('./targetInventory/first.vue')),
                meta: { hideBarHead: true, hideBarFoot: true },
            },
            {
                path: '/okr/targetInventory/subordinateList',
                component: () => spinRoute.require(import('./targetInventory/subordinateList.vue')),
                meta: { title: '下属列表', hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/targetInventory/fillJournal',
                component: () => spinRoute.require(import('./targetInventory/fillJournal.vue')),
                meta: { title: '填写报告', hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/targetInventory/reportDetail',
                component: () => spinRoute.require(import('./targetInventory/reportDetail.vue')),
                meta: { title: '报告详情', hideBarHead: true, hideBarFoot: true }
            },

            {
                path: '/okr/targetInventory/reportTemplate',
                component: () => spinRoute.require(import('./targetInventory/reportTemplate.vue')),
                meta: { title: '报告模板选择', hideBarHead: true, hideBarFoot: true }
            },
            {
                path: '/okr/SubObjs',
                component: () => spinRoute.require(import('./subObjectProcess/subObjectProcess.vue')),
                meta: { title: '下属目标进度', hideBarHead: true, hideBarFoot: true, setFullScreen: true }
            },
            {
                path: '/okr/alignView',
                component: () => spinRoute.require(import('./alignView/alignview.vue')),
                meta: { title: '对齐视图', hideBarHead: true, hideBarFoot: true, setFullScreen: true }
            },
            {
                path: '/okr/myrt',
                component: () => spinRoute.require(import('./views/myrt.vue')),
                meta: { title: '统计分析', hideBarHead: true, hideBarFoot: true },
            },
        ],
    },
]
